/** @jsxImportSource @emotion/react */

import { FC } from 'react'
import { AchievementTypeEnum, RewardTypeEnum } from '__generatedTypes__/globalTypes'
import { LEVEL_IMAGE_MAP, getRewardImageSrc } from './consts'
import * as classes from './styles'

type CommonProps = {
  'data-testid'?: string
}

type AchievementsProps = CommonProps & {
  tab: 'achievements'
  level?: string
  achievementType: AchievementTypeEnum
}

type RewardsProps = CommonProps & {
  tab: 'rewards'
  rewardType: RewardTypeEnum
  mode: 'light' | 'dark'
  subType?: string
}

type Props = AchievementsProps | RewardsProps

export const AchievementsRewardsImagePreview: FC<Props> = (props: Props) => {
  const testId = props['data-testid']

  if (props.tab === 'achievements') {
    const { level, achievementType } = props

    const renderImage = () => {
      if (!achievementType || !level) {
        return null
      }

      const src = LEVEL_IMAGE_MAP[achievementType]?.[level]

      // eslint-disable-next-line jsx-a11y/img-redundant-alt
      return src ? <img css={classes.imagePreview} src={src} alt="Level image" data-testid={testId} /> : null
    }

    return <div css={classes.achievementImagePreviewWrapper}>{renderImage()}</div>
  }

  if (props.tab === 'rewards') {
    const renderImage = () => {
      const { rewardType, mode, subType } = props

      if (!rewardType) {
        return null
      }

      const src = getRewardImageSrc(rewardType, mode, subType)

      // eslint-disable-next-line
      return src ? <img css={classes.imagePreview} src={src} alt={`Reward image ${mode}`} data-testid={testId} /> : null
    }

    return <div css={classes.achievementImagePreviewWrapper}>{renderImage()}</div>
  }

  return null
}
